import { Label } from '~/components/ui/label'
import { cn } from '~/lib/utils'

export interface FieldProps {
  id?: string
  label?: string
  required?: boolean
  optional?: boolean
  children: React.ReactNode
  error?: string
  className?: string
  labelClassName?: string
}

export const Field = ({
  id,
  label,
  children,
  error,
  required,
  optional,
  className,
  labelClassName,
}: FieldProps) => {
  if (!label) {
    return (
      <div className={cn('flex flex-col gap-1', className)} aria-invalid={error ? true : undefined}>
        {children}
        {error && <em className="text-destructive text-xs opacity-70">{error}</em>}
      </div>
    )
  }

  return (
    <div className={cn('flex flex-col gap-1', className)} aria-invalid={error ? true : undefined}>
      <Label htmlFor={id} className={cn('flex flex-col gap-1 items-start', labelClassName)}>
        <span className="text-sm flex gap-0.5 items-center">
          {label}
          {required && <span className="text-destructive">*</span>}
          {optional && <span className="text-muted-foreground text-xs">(facultatif)</span>}
        </span>
        {children}
      </Label>
      {error && <em className="text-destructive text-xs opacity-70">{error}</em>}
    </div>
  )
}
